import {
  ObserverChange,
  ObserverChangeField,
  UserRole,
  UsersResponse,
  convertUser,
} from '@nextforce/api'

export function convertObserverChangeResponse(
  response: UsersResponse.ObserverChangeResponse
): ObserverChange[] {
  return response.user_audits.map(observer =>
    convertObserverChange(observer, response.user)
  )
}

export function convertObserverChange(
  response: UsersResponse.ObserverChange,
  user: UsersResponse.User
): ObserverChange {
  return {
    changedAt: response.changed_at,
    type: getObserverChangeType(response.type),
    changedBy: convertUser(response.changed_by),
    user: convertUser(user),
    changedFrom: convertObserverFields(response.changed_from),
    changedTo: convertObserverFields(response.changed_to),
  }
}

function getObserverChangeType(
  type: UsersResponse.ObserverChange['type']
): ObserverChange['type'] {
  switch (type) {
    case 'ADD':
      return 'add'
    case 'UPDATE':
      return 'edit'
    case 'REMOVE':
      return 'remove'
  }
}

function convertObserverFields(
  response:
    | undefined
    | {
        [fieldName in UsersResponse.ObserverChangeField]?: string
      }
): { [fieldName in ObserverChangeField]?: string } {
  if (response) {
    return Object.keys(response).reduce((acc, key) => {
      const field = getObserverFieldKey(
        key as UsersResponse.ObserverChangeField
      )
      acc[field] = response[key]
      return acc
    }, {})
  }
  return {}
}

function getObserverFieldKey(
  key: UsersResponse.ObserverChangeField
): ObserverChangeField {
  switch (key) {
    case 'ADDED_TO_STORES':
      return 'addedToStores'
    case 'REMOVED_FROM_STORES':
      return 'removedFromStores'
    case 'FIRST_NAME':
      return 'firstName'
    case 'LAST_NAME':
      return 'lastName'
    case 'PHONE_NUMBER':
      return 'phoneNumber'
    default:
      return key
  }
}

export function convertUserRoleToQueryParam(
  role: UserRole | undefined
): UsersResponse.Role | undefined {
  switch (role) {
    case 'observer':
      return 'ROLE_OBSERVER'
    case 'staff':
      return 'ROLE_STAFF'
    case 'guest':
      return 'ROLE_GUEST'
    case 'manager':
      return 'ROLE_MANAGER'
    case 'helper':
      return 'ROLE_HELPER'
  }
}
